<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      class="b"
      d="M3 17.21v-5.88a8.91 8.91 0 019-8.83 8.91 8.91 0 019 8.83v5.88"
    />
    <path
      class="b"
      d="M21 18.3a2.1 2.1 0 01-2 2.2h-1a2.1 2.1 0 01-2-2.2v-3.28a2.1 2.1 0 012-2.2h3zm-18 0a2.1 2.1 0 002 2.2h1a2.1 2.1 0 002-2.2v-3.28a2.1 2.1 0 00-2-2.2H3z"
    />
  </g>
</template>
<style scoped>
.b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7px}
</style>